"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.script = {
    0x20: [0, 0, .25],
    0x41: [.717, .008, .803, { ic: .213, sk: .389 }],
    0x42: [.708, .028, .908, { ic: .02, sk: .194 }],
    0x43: [.728, .026, .666, { ic: .153, sk: .278 }],
    0x44: [.708, .031, .774, { ic: .081, sk: .111 }],
    0x45: [.707, .008, .562, { ic: .156, sk: .139 }],
    0x46: [.735, .036, .895, { ic: .095, sk: .222 }],
    0x47: [.717, .037, .61, { ic: .128, sk: .25 }],
    0x48: [.717, .036, .969, { ic: .272, sk: .333 }],
    0x49: [.717, .017, .809, { ic: .137, sk: .333 }],
    0x4A: [.717, .314, 1.052, { ic: .081, sk: .417 }],
    0x4B: [.717, .037, .914, { ic: .29, sk: .361 }],
    0x4C: [.717, .017, .874, { ic: .161, sk: .306 }],
    0x4D: [.721, .05, 1.08, { ic: .136, sk: .444 }],
    0x4E: [.726, .036, .902, { ic: .306, sk: .389 }],
    0x4F: [.707, .008, .738, { ic: .067, sk: .167 }],
    0x50: [.716, .037, 1.013, { ic: .018, sk: .222 }],
    0x51: [.717, .017, .883, { sk: .278 }],
    0x52: [.717, .017, .85, { ic: .037, sk: .194 }],
    0x53: [.708, .036, .868, { ic: .148, sk: .333 }],
    0x54: [.735, .037, .747, { ic: .249, sk: .222 }],
    0x55: [.717, .017, .8, { ic: .16, sk: .25 }],
    0x56: [.717, .017, .622, { ic: .228, sk: .222 }],
    0x57: [.717, .017, .805, { ic: .221, sk: .25 }],
    0x58: [.717, .017, .944, { ic: .187, sk: .278 }],
    0x59: [.716, .017, .71, { ic: .249, sk: .194 }],
    0x5A: [.717, .016, .821, { ic: .211, sk: .306 }],
    0xA0: [0, 0, .25],
    0x391: [.716, 0, .75],
    0x392: [.683, 0, .708],
    0x395: [.68, 0, .681],
    0x396: [.683, 0, .611],
    0x397: [.683, 0, .75],
    0x399: [.683, 0, .361],
    0x39A: [.683, 0, .778],
    0x39C: [.683, 0, .917],
    0x39D: [.683, 0, .75],
    0x39F: [.705, .022, .778],
    0x3A1: [.683, 0, .681],
    0x3A2: [.705, .022, .778],
    0x3A4: [.677, 0, .722],
    0x3A7: [.683, 0, .75],
    0x3D2: [.705, 0, .778],
    0x3DC: [.68, 0, .653],
    0x210B: [.717, .036, .969, { ic: .272, sk: .333 }],
    0x2110: [.717, .314, 1.052, { ic: .081, sk: .417 }],
    0x2112: [.717, .017, .874, { ic: .161, sk: .306 }],
    0x211B: [.717, .017, .85, { ic: .037, sk: .194 }],
    0x212C: [.708, .028, .908, { ic: .02, sk: .194 }],
    0x2130: [.707, .008, .562, { ic: .156, sk: .139 }],
    0x2131: [.735, .036, .895, { ic: .095, sk: .222 }],
    0x2133: [.721, .05, 1.08, { ic: .136, sk: .444 }],
};
//# sourceMappingURL=script.js.map